"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHtml = renderHtml;
exports.renderTemplate = renderTemplate;
var react_html_parser_1 = require("react-html-parser");
var journey_services_1 = require("@athena-portal/journey-services");
function renderHtml(htmlText, interaction) {
    return (0, react_html_parser_1.default)(renderTemplate(htmlText, interaction, true), {
        transform: function (node) {
            if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                return null;
            }
            return;
        }
    });
}
function renderTemplate(template, interaction, escapeFields) {
    return journey_services_1.ExpressionEvaluator.renderTemplate(template, interaction, escapeFields);
}
//# sourceMappingURL=RenderUtils.js.map